import React, { useEffect, useState, createElement } from 'react';
import { SalesPage } from './components/SalesPage';
import { TermsPage } from './pages/TermsPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { initMetaPixel } from './utils/metaPixel';
type Page = 'home' | 'terms' | 'privacy';
export function App() {
  const [currentPage, setCurrentPage] = useState<Page>('home');
  useEffect(() => {
    document.title = 'CPAP Compliance Rescue — Sleep Through the Night in 30 Days';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', 'A calm, step-by-step plan for men 65+ to get through the first 30 nights with CPAP without quitting.');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = 'A calm, step-by-step plan for men 65+ to get through the first 30 nights with CPAP without quitting.';
      document.head.appendChild(meta);
    }
    initMetaPixel();
  }, []);
  const navigate = (page: Page) => {
    setCurrentPage(page);
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return <>
      {currentPage === 'home' && <SalesPage onNavigate={page => navigate(page)} data-id="element-0" />}
      {currentPage === 'terms' && <TermsPage onBack={() => navigate('home')} data-id="element-1" />}
      {currentPage === 'privacy' && <PrivacyPage onBack={() => navigate('home')} data-id="element-2" />}
    </>;
}